import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { createAgreementService } from "../../api/Agreement";
import toast from "react-hot-toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage";
import EditForm from "../../components/EditForm";
import AgreementServiceForm from "../../components/agreementService/AgreementServiceForm";
import Breadcrumbs from "../../components/Breadcrumbs";
import { getBillingGroupsByAgreement } from "../../api/BillingGroups";

const CreateAgreementServicesPage = () => {
  const { getAccessToken, user } = useAuth();
  const { agreementPublicId } = useParams();
  const navigate = useNavigate();
  const [agreementService, setAgreementService] = useState({
    name: "",
    comment: "",
    isActiveForAgreement: "",
    category: "",
  });
  const [hasChanges, setHasChanges] = useState(false);
  const [billingGroups, setBillingGroups] = useState([]);
  const [confirmState, setConfirmState] = useState({ isOpen: false });

  const handleCreateAgreementService = async () => {
    try {
      const accessToken = await getAccessToken();
      if (!accessToken) {
        toast.error("Authorization failed. Please log in again.");
        return;
      }

      const serviceData = {
        name: agreementService.name || "",
        categoryPublicId: agreementService.categoryPublicId || null,
        websiteUrl: agreementService.websiteUrl || null,
      };

      await createAgreementService(serviceData, accessToken);
      
      toast.success("Agreement service created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });

      navigate(-1);
    } catch (error) {
      toast.error(error.message || "Failed to create agreement service");
    }
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute w-full pointer-events-none">
            <LoadingTablePage title={"Create agreement service"} loading={false} />
          </div>
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <button onClick={() => navigate(-1)} className="text-black flex">
                <FontAwesomeIcon icon={faArrowLeftLong} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4">Create agreement service</h2>
              <div className="flex gap-4 ml-auto">
                <button className="btn btn-outline-primary" onClick={() => navigate(-1)}>Cancel</button>
                <button className="btn btn-primary" disabled={!hasChanges} onClick={handleCreateAgreementService}>
                Save
                </button>
              </div>
            </div>
            <div className="flex flex-col px-4 py-8 shadow-lg border rounded-md w-full gap-4">
            <AgreementServiceForm
            agreementService={agreementService}
            setAgreementService={setAgreementService}
            setHasChanges={setHasChanges}
            disabledFields={[
                "agreementServicePublicId",
                "comment",
                "isActiveForAgreement",
              ]}
          />
            </div>
          </div>
        </main>
      </div>
      <ConfirmationModal isOpen={confirmState.isOpen} onClose={() => setConfirmState({ isOpen: false })} />
    </>
  );
};

export default CreateAgreementServicesPage;
